export const countries = [
  {
    "Market": "Argentina",
    "Currency": "$US",
    "Marketing": 0.0618,
    "Utility": {
      "base_rate": 0.0260,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0260, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0247, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0234, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 15000000, "rate": 0.0221, "type": "Tier rate", "discount": "15%" },
        { "from": 15000001, "to": 30000000, "rate": 0.0208, "type": "Tier rate", "discount": "20%" },
        { "from": 30000001, "to": null, "rate": 0.0195, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0260,
      "tiers": [
        { "from": 0, "to": 120000, "rate": 0.0260, "type": "List rate" },
        { "from": 120001, "to": 400000, "rate": 0.0247, "type": "Tier rate", "discount": "5%" },
        { "from": 400001, "to": 1000000, "rate": 0.0234, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 5000000, "rate": 0.0221, "type": "Tier rate", "discount": "15%" },
        { "from": 5000001, "to": 10000000, "rate": 0.0208, "type": "Tier rate", "discount": "20%" },
        { "from": 10000001, "to": null, "rate": 0.0195, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0260,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Bangladesh",
    "Currency": "$US",
    "Marketing": 0.0732,
    "Utility": {
      "base_rate": 0.0037,
      "tiers": [
        { "from": 0, "to": 150000, "rate": 0.0037, "type": "List rate" },
        { "from": 150001, "to": 1000000, "rate": 0.0035, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4000000, "rate": 0.0033, "type": "Tier rate", "discount": "10%" },
        { "from": 4000001, "to": 25000000, "rate": 0.0031, "type": "Tier rate", "discount": "15%" },
        { "from": 25000001, "to": 50000000, "rate": 0.0030, "type": "Tier rate", "discount": "20%" },
        { "from": 50000001, "to": null, "rate": 0.0028, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0037,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0037, "type": "List rate" },
        { "from": 100001, "to": 300000, "rate": 0.0035, "type": "Tier rate", "discount": "5%" },
        { "from": 300001, "to": 1000000, "rate": 0.0033, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 10000000, "rate": 0.0031, "type": "Tier rate", "discount": "15%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0030, "type": "Tier rate", "discount": "20%" },
        { "from": 20000001, "to": null, "rate": 0.0028, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0037,
    "Authentication_International": {
      "base_rate": 0.0960,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0960, "type": "List rate" },
        { "from": 100001, "to": 300000, "rate": 0.0912, "type": "Tier rate", "discount": "5%" },
        { "from": 300001, "to": 1000000, "rate": 0.0864, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 10000000, "rate": 0.0816, "type": "Tier rate", "discount": "15%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0768, "type": "Tier rate", "discount": "20%" },
        { "from": 20000001, "to": null, "rate": 0.0720, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "Brazil",
    "Currency": "$US",
    "Marketing": 0.0625,
    "Utility": {
      "base_rate": 0.0068,
      "tiers": [
        { "from": 0, "to": 250000, "rate": 0.0068, "type": "List rate" },
        { "from": 250001, "to": 2000000, "rate": 0.0065, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 17000000, "rate": 0.0061, "type": "Tier rate", "discount": "10%" },
        { "from": 17000001, "to": 35000000, "rate": 0.0058, "type": "Tier rate", "discount": "15%" },
        { "from": 35000001, "to": 70000000, "rate": 0.0054, "type": "Tier rate", "discount": "20%" },
        { "from": 70000001, "to": null, "rate": 0.0051, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0068,
      "tiers": [
        { "from": 0, "to": 500000, "rate": 0.0068, "type": "List rate" },
        { "from": 500001, "to": 3000000, "rate": 0.0065, "type": "Tier rate", "discount": "5%" },
        { "from": 3000001, "to": 5250000, "rate": 0.0061, "type": "Tier rate", "discount": "10%" },
        { "from": 5250001, "to": 10000000, "rate": 0.0058, "type": "Tier rate", "discount": "15%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0054, "type": "Tier rate", "discount": "20%" },
        { "from": 20000001, "to": null, "rate": 0.0051, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0068,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Chile",
    "Currency": "$US",
    "Marketing": 0.0889,
    "Utility": {
      "base_rate": 0.0200,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0200, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0190, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0180, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 15000000, "rate": 0.0170, "type": "Tier rate", "discount": "15%" },
        { "from": 15000001, "to": 30000000, "rate": 0.0160, "type": "Tier rate", "discount": "20%" },
        { "from": 30000001, "to": null, "rate": 0.0150, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0200,
      "tiers": [
        { "from": 0, "to": 120000, "rate": 0.0200, "type": "List rate" },
        { "from": 120001, "to": 400000, "rate": 0.0190, "type": "Tier rate", "discount": "5%" },
        { "from": 400001, "to": 1000000, "rate": 0.0180, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 5000000, "rate": 0.0170, "type": "Tier rate", "discount": "15%" },
        { "from": 5000001, "to": 10000000, "rate": 0.0160, "type": "Tier rate", "discount": "20%" },
        { "from": 10000001, "to": null, "rate": 0.0150, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0200,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Colombia",
    "Currency": "$US",
    "Marketing": 0.0125,
    "Utility": {
      "base_rate": 0.0008,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0008, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0008, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0007, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 15000000, "rate": 0.0007, "type": "Tier rate", "discount": "15%" },
        { "from": 15000001, "to": 30000000, "rate": 0.0006, "type": "Tier rate", "discount": "20%" },
        { "from": 30000001, "to": null, "rate": 0.0006, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0008,
      "tiers": [
        { "from": 0, "to": 120000, "rate": 0.0008, "type": "List rate" },
        { "from": 120001, "to": 400000, "rate": 0.0008, "type": "Tier rate", "discount": "5%" },
        { "from": 400001, "to": 1000000, "rate": 0.0007, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 5000000, "rate": 0.0007, "type": "Tier rate", "discount": "15%" },
        { "from": 5000001, "to": 10000000, "rate": 0.0006, "type": "Tier rate", "discount": "20%" },
        { "from": 10000001, "to": null, "rate": 0.0006, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0008,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Egypt",
    "Currency": "$US",
    "Marketing": 0.0644,
    "Utility": {
      "base_rate": 0.0036,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0036, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0034, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0032, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0031, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0029, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0027, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0036,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0036, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0034, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0032, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0031, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0029, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0027, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0036,
    "Authentication_International": {
      "base_rate": 0.0650,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0650, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0618, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0585, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0553, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0520, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0488, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "France",
    "Currency": "$US",
    "Marketing": 0.0859,
    "Utility": {
      "base_rate": 0.0300,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0300, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0285, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0270, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0255, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0240, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0225, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0300,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0300, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0285, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0270, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0255, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0240, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0225, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0300,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Germany",
    "Currency": "$US",
    "Marketing": 0.1365,
    "Utility": {
      "base_rate": 0.0550,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0550, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0523, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0495, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0468, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0440, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0413, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0550,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0550, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0523, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0495, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0468, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0440, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0413, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0550,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Hong Kong",
    "Currency": "$US",
    "Marketing": 0.0732,
    "Utility": {
      "base_rate": 0.0260,
      "tiers": [
        { "from": 0, "to": 150000, "rate": 0.0260, "type": "List rate" },
        { "from": 150001, "to": 1000000, "rate": 0.0247, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4000000, "rate": 0.0234, "type": "Tier rate", "discount": "10%" },
        { "from": 4000001, "to": 25000000, "rate": 0.0221, "type": "Tier rate", "discount": "15%" },
        { "from": 25000001, "to": 50000000, "rate": 0.0208, "type": "Tier rate", "discount": "20%" },
        { "from": 50000001, "to": null, "rate": 0.0195, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0260,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0260, "type": "List rate" },
        { "from": 100001, "to": 300000, "rate": 0.0247, "type": "Tier rate", "discount": "5%" },
        { "from": 300001, "to": 1000000, "rate": 0.0234, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 10000000, "rate": 0.0221, "type": "Tier rate", "discount": "15%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0208, "type": "Tier rate", "discount": "20%" },
        { "from": 20000001, "to": null, "rate": 0.0195, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0260,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Hungary",
    "Currency": "$US",
    "Marketing": 0.0860,
    "Utility": {
      "base_rate": 0.0350,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0350, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0333, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0315, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0298, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0280, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0263, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0350,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0350, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0333, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0315, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0298, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0280, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0263, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0350,
    "Authentication_International": "N/A"
  },
  {
    "Market": "India",
    "Currency": "$US",
    "Marketing": 0.0118,
    "Utility": {
      "base_rate": 0.0014,
      "tiers": [
        { "from": 0, "to": 25000000, "rate": 0.0014, "type": "List rate" },
        { "from": 25000001, "to": 50000000, "rate": 0.0013, "type": "Tier rate", "discount": "6%" },
        { "from": 50000001, "to": 100000000, "rate": 0.0012, "type": "Tier rate", "discount": "12%" },
        { "from": 100000001, "to": 200000000, "rate": 0.0011, "type": "Tier rate", "discount": "18%" },
        { "from": 200000001, "to": 300000000, "rate": 0.0011, "type": "Tier rate", "discount": "24%" },
        { "from": 300000001, "to": null, "rate": 0.0010, "type": "Tier rate", "discount": "30%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0014,
      "tiers": [
        { "from": 0, "to": 750000, "rate": 0.0014, "type": "List rate" },
        { "from": 750001, "to": 15000000, "rate": 0.0013, "type": "Tier rate", "discount": "6%" },
        { "from": 15000001, "to": 20000000, "rate": 0.0012, "type": "Tier rate", "discount": "12%" },
        { "from": 20000001, "to": 50000000, "rate": 0.0011, "type": "Tier rate", "discount": "18%" },
        { "from": 50000001, "to": 100000000, "rate": 0.0011, "type": "Tier rate", "discount": "24%" },
        { "from": 100000001, "to": null, "rate": 0.0010, "type": "Tier rate", "discount": "30%" }
      ]
    },
    "Service": 0.0014,
    "Authentication_International": {
      "base_rate": 0.0304,
      "tiers": [
        { "from": 0, "to": 750000, "rate": 0.0304, "type": "List rate" },
        { "from": 750001, "to": 15000000, "rate": 0.0286, "type": "Tier rate", "discount": "6%" },
        { "from": 15000001, "to": 20000000, "rate": 0.0268, "type": "Tier rate", "discount": "12%" },
        { "from": 20000001, "to": 50000000, "rate": 0.0249, "type": "Tier rate", "discount": "18%" },
        { "from": 50000001, "to": 100000000, "rate": 0.0231, "type": "Tier rate", "discount": "24%" },
        { "from": 100000001, "to": null, "rate": 0.0213, "type": "Tier rate", "discount": "30%" }
      ]
    }
  },
  {
    "Market": "Indonesia",
    "Currency": "$US",
    "Marketing": 0.0411,
    "Utility": {
      "base_rate": 0.0250,
      "tiers": [
        { "from": 0, "to": 750000, "rate": 0.0250, "type": "List rate" },
        { "from": 750001, "to": 4000000, "rate": 0.0238, "type": "Tier rate", "discount": "5%" },
        { "from": 4000001, "to": 25000000, "rate": 0.0225, "type": "Tier rate", "discount": "10%" },
        { "from": 25000001, "to": 75000000, "rate": 0.0213, "type": "Tier rate", "discount": "15%" },
        { "from": 75000001, "to": 150000000, "rate": 0.0200, "type": "Tier rate", "discount": "20%" },
        { "from": 150000001, "to": null, "rate": 0.0188, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0250,
      "tiers": [
        { "from": 0, "to": 750000, "rate": 0.0250, "type": "List rate" },
        { "from": 750001, "to": 2000000, "rate": 0.0238, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 6000000, "rate": 0.0225, "type": "Tier rate", "discount": "10%" },
        { "from": 6000001, "to": 30000000, "rate": 0.0213, "type": "Tier rate", "discount": "15%" },
        { "from": 30000001, "to": 60000000, "rate": 0.0200, "type": "Tier rate", "discount": "20%" },
        { "from": 60000001, "to": null, "rate": 0.0188, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0250,
    "Authentication_International": {
      "base_rate": 0.1360,
      "tiers": [
        { "from": 0, "to": 750000, "rate": 0.1360, "type": "List rate" },
        { "from": 750001, "to": 2000000, "rate": 0.1292, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 6000000, "rate": 0.1224, "type": "Tier rate", "discount": "10%" },
        { "from": 6000001, "to": 30000000, "rate": 0.1156, "type": "Tier rate", "discount": "15%" },
        { "from": 30000001, "to": 60000000, "rate": 0.1088, "type": "Tier rate", "discount": "20%" },
        { "from": 60000001, "to": null, "rate": 0.1020, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "Iraq",
    "Currency": "$US",
    "Marketing": 0.0341,
    "Utility": {
      "base_rate": 0.0079,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0079, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0075, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0071, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0067, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0063, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0059, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0079,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0079, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0075, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0071, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0067, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0063, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0059, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0079,
    "Authentication_International": {
      "base_rate": 0.1280,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.1280, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.1216, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.1152, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.1088, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.1024, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0960, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "Italy",
    "Currency": "$US",
    "Marketing": 0.0795,
    "Utility": {
      "base_rate": 0.0300,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0300, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0285, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0270, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0255, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0240, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0225, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0300,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0300, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0285, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0270, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0255, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0240, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0225, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0300,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Kazakhstan",
    "Currency": "$US",
    "Marketing": 0.0604,
    "Utility": {
      "base_rate": 0.0180,
      "tiers": [
        { "from": 0, "to": 80000, "rate": 0.0180, "type": "List rate" },
        { "from": 80001, "to": 750000, "rate": 0.0171, "type": "Tier rate", "discount": "5%" },
        { "from": 750001, "to": 2250000, "rate": 0.0162, "type": "Tier rate", "discount": "10%" },
        { "from": 2250001, "to": 3000000, "rate": 0.0153, "type": "Tier rate", "discount": "15%" },
        { "from": 3000001, "to": 6000000, "rate": 0.0144, "type": "Tier rate", "discount": "20%" },
        { "from": 6000001, "to": null, "rate": 0.0135, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0180,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0180, "type": "List rate" },
        { "from": 100001, "to": 500000, "rate": 0.0171, "type": "Tier rate", "discount": "5%" },
        { "from": 500001, "to": 2000000, "rate": 0.0162, "type": "Tier rate", "discount": "10%" },
        { "from": 2000001, "to": 5000000, "rate": 0.0153, "type": "Tier rate", "discount": "15%" },
        { "from": 5000001, "to": 10000000, "rate": 0.0144, "type": "Tier rate", "discount": "20%" },
        { "from": 10000001, "to": null, "rate": 0.0135, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0180,
    "Authentication_International": {
      "base_rate": 0.1600,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.1600, "type": "List rate" },
        { "from": 100001, "to": 500000, "rate": 0.1520, "type": "Tier rate", "discount": "5%" },
        { "from": 500001, "to": 2000000, "rate": 0.1440, "type": "Tier rate", "discount": "10%" },
        { "from": 2000001, "to": 5000000, "rate": 0.1360, "type": "Tier rate", "discount": "15%" },
        { "from": 5000001, "to": 10000000, "rate": 0.1280, "type": "Tier rate", "discount": "20%" },
        { "from": 10000001, "to": null, "rate": 0.1200, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "Kuwait",
    "Currency": "$US",
    "Marketing": 0.0792,
    "Utility": {
      "base_rate": 0.0440,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0440, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0418, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0396, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0374, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0352, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0330, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0440,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0440, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0418, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0396, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0374, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0352, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0330, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0440,
    "Authentication_International": {
      "base_rate": 0.1200,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.1200, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.1140, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.1080, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.1020, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0960, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0900, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "Malaysia",
    "Currency": "$US",
    "Marketing": 0.0860,
    "Utility": {
      "base_rate": 0.0140,
      "tiers": [
        { "from": 0, "to": 150000, "rate": 0.0140, "type": "List rate" },
        { "from": 150001, "to": 1000000, "rate": 0.0133, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4000000, "rate": 0.0126, "type": "Tier rate", "discount": "10%" },
        { "from": 4000001, "to": 25000000, "rate": 0.0119, "type": "Tier rate", "discount": "15%" },
        { "from": 25000001, "to": 50000000, "rate": 0.0112, "type": "Tier rate", "discount": "20%" },
        { "from": 50000001, "to": null, "rate": 0.0105, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0140,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0140, "type": "List rate" },
        { "from": 100001, "to": 300000, "rate": 0.0133, "type": "Tier rate", "discount": "5%" },
        { "from": 300001, "to": 1000000, "rate": 0.0126, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 10000000, "rate": 0.0119, "type": "Tier rate", "discount": "15%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0112, "type": "Tier rate", "discount": "20%" },
        { "from": 20000001, "to": null, "rate": 0.0105, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0140,
    "Authentication_International": {
      "base_rate": 0.0418,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0418, "type": "List rate" },
        { "from": 100001, "to": 300000, "rate": 0.0397, "type": "Tier rate", "discount": "5%" },
        { "from": 300001, "to": 1000000, "rate": 0.0376, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 10000000, "rate": 0.0355, "type": "Tier rate", "discount": "15%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0334, "type": "Tier rate", "discount": "20%" },
        { "from": 20000001, "to": null, "rate": 0.0314, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "Mexico",
    "Currency": "$US",
    "Marketing": 0.0397,
    "Utility": {
      "base_rate": 0.0085,
      "tiers": [
        { "from": 0, "to": 1000000, "rate": 0.0085, "type": "List rate" },
        { "from": 1000001, "to": 5000000, "rate": 0.0081, "type": "Tier rate", "discount": "5%" },
        { "from": 5000001, "to": 10000000, "rate": 0.0077, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0072, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0068, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0064, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0085,
      "tiers": [
        { "from": 0, "to": 250000, "rate": 0.0085, "type": "List rate" },
        { "from": 250001, "to": 1000000, "rate": 0.0081, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 3000000, "rate": 0.0077, "type": "Tier rate", "discount": "10%" },
        { "from": 3000001, "to": 5000000, "rate": 0.0072, "type": "Tier rate", "discount": "15%" },
        { "from": 5000001, "to": 10000000, "rate": 0.0068, "type": "Tier rate", "discount": "20%" },
        { "from": 10000001, "to": null, "rate": 0.0064, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0085,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Morocco",
    "Currency": "$US",
    "Marketing": 0.0414,
    "Utility": {
      "base_rate": 0.0230,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0230, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0219, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0207, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0196, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0184, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0173, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0230,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0230, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0219, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0207, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0196, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0184, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0173, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0230,
    "Authentication_International": {
      "base_rate": 0.0811,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0811, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0770, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0730, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0689, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0649, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0608, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "Nepal",
    "Currency": "$US",
    "Marketing": 0.0732,
    "Utility": {
      "base_rate": 0.0034,
      "tiers": [
        { "from": 0, "to": 150000, "rate": 0.0034, "type": "List rate" },
        { "from": 150001, "to": 1000000, "rate": 0.0032, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4000000, "rate": 0.0031, "type": "Tier rate", "discount": "10%" },
        { "from": 4000001, "to": 25000000, "rate": 0.0029, "type": "Tier rate", "discount": "15%" },
        { "from": 25000001, "to": 50000000, "rate": 0.0027, "type": "Tier rate", "discount": "20%" },
        { "from": 50000001, "to": null, "rate": 0.0026, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0034,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0034, "type": "List rate" },
        { "from": 100001, "to": 300000, "rate": 0.0032, "type": "Tier rate", "discount": "5%" },
        { "from": 300001, "to": 1000000, "rate": 0.0031, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 10000000, "rate": 0.0029, "type": "Tier rate", "discount": "15%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0027, "type": "Tier rate", "discount": "20%" },
        { "from": 20000001, "to": null, "rate": 0.0026, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0034,
    "Authentication_International": {
      "base_rate": 0.1120,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.1120, "type": "List rate" },
        { "from": 100001, "to": 300000, "rate": 0.1064, "type": "Tier rate", "discount": "5%" },
        { "from": 300001, "to": 1000000, "rate": 0.1008, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 10000000, "rate": 0.0952, "type": "Tier rate", "discount": "15%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0896, "type": "Tier rate", "discount": "20%" },
        { "from": 20000001, "to": null, "rate": 0.0840, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "Netherlands",
    "Currency": "$US",
    "Marketing": 0.1597,
    "Utility": {
      "base_rate": 0.0500,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0500, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0475, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0450, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0425, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0400, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0375, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0500,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0500, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0475, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0450, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0425, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0400, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0375, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0500,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Nigeria",
    "Currency": "$US",
    "Marketing": 0.0516,
    "Utility": {
      "base_rate": 0.0067,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0067, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0064, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0060, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0057, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0054, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0050, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0067,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0067, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0064, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0060, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0057, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0054, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0050, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0067,
    "Authentication_International": {
      "base_rate": 0.0750,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0750, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0713, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0675, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0638, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0600, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0563, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "Oman",
    "Currency": "$US",
    "Marketing": 0.0341,
    "Utility": {
      "base_rate": 0.0247,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0247, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0235, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0222, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0210, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0198, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0185, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0247,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0247, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0235, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0222, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0210, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0198, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0185, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0247,
    "Authentication_International": {
      "base_rate": 0.0600,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0600, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0570, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0540, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0510, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0480, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0450, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "Pakistan",
    "Currency": "$US",
    "Marketing": 0.0473,
    "Utility": {
      "base_rate": 0.0150,
      "tiers": [
        { "from": 0, "to": 150000, "rate": 0.0150, "type": "List rate" },
        { "from": 150001, "to": 1000000, "rate": 0.0143, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4000000, "rate": 0.0135, "type": "Tier rate", "discount": "10%" },
        { "from": 4000001, "to": 25000000, "rate": 0.0128, "type": "Tier rate", "discount": "15%" },
        { "from": 25000001, "to": 50000000, "rate": 0.0120, "type": "Tier rate", "discount": "20%" },
        { "from": 50000001, "to": null, "rate": 0.0113, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0150,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0150, "type": "List rate" },
        { "from": 100001, "to": 300000, "rate": 0.0143, "type": "Tier rate", "discount": "5%" },
        { "from": 300001, "to": 1000000, "rate": 0.0135, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 10000000, "rate": 0.0128, "type": "Tier rate", "discount": "15%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0120, "type": "Tier rate", "discount": "20%" },
        { "from": 20000001, "to": null, "rate": 0.0113, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0150,
    "Authentication_International": {
      "base_rate": 0.0750,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0750, "type": "List rate" },
        { "from": 100001, "to": 300000, "rate": 0.0713, "type": "Tier rate", "discount": "5%" },
        { "from": 300001, "to": 1000000, "rate": 0.0675, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 10000000, "rate": 0.0638, "type": "Tier rate", "discount": "15%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0600, "type": "Tier rate", "discount": "20%" },
        { "from": 20000001, "to": null, "rate": 0.0563, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "Peru",
    "Currency": "$US",
    "Marketing": 0.0703,
    "Utility": {
      "base_rate": 0.0300,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0300, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0285, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0270, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 15000000, "rate": 0.0255, "type": "Tier rate", "discount": "15%" },
        { "from": 15000001, "to": 30000000, "rate": 0.0240, "type": "Tier rate", "discount": "20%" },
        { "from": 30000001, "to": null, "rate": 0.0225, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0300,
      "tiers": [
        { "from": 0, "to": 120000, "rate": 0.0300, "type": "List rate" },
        { "from": 120001, "to": 400000, "rate": 0.0285, "type": "Tier rate", "discount": "5%" },
        { "from": 400001, "to": 1000000, "rate": 0.0270, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 5000000, "rate": 0.0255, "type": "Tier rate", "discount": "15%" },
        { "from": 5000001, "to": 10000000, "rate": 0.0240, "type": "Tier rate", "discount": "20%" },
        { "from": 10000001, "to": null, "rate": 0.0225, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0300,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Poland",
    "Currency": "$US",
    "Marketing": 0.0366,
    "Utility": {
      "base_rate": 0.0122,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0122, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0116, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0110, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0104, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0098, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0092, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0122,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0122, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0116, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0110, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0104, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0098, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0092, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0122,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Qatar",
    "Currency": "$US",
    "Marketing": 0.0341,
    "Utility": {
      "base_rate": 0.0120,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0120, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0114, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0108, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0102, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0096, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0090, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0120,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0120, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0114, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0108, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0102, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0096, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0090, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0120,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Romania",
    "Currency": "$US",
    "Marketing": 0.0860,
    "Utility": {
      "base_rate": 0.0290,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0290, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0276, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0261, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0247, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0232, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0218, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0290,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0290, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0276, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0261, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0247, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0232, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0218, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0290,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Russia",
    "Currency": "$US",
    "Marketing": 0.0802,
    "Utility": {
      "base_rate": 0.0400,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0400, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0380, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0360, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0340, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0320, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0300, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0400,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0400, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0380, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0360, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0340, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0320, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0300, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0400,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Saudi Arabia",
    "Currency": "$US",
    "Marketing": 0.0576,
    "Utility": {
      "base_rate": 0.0107,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0107, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0102, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0096, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0091, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0086, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0080, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0107,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0107, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0102, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0096, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0091, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0086, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0080, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0107,
    "Authentication_International": {
      "base_rate": 0.0598,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0598, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0568, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0538, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0508, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0478, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0449, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "Singapore",
    "Currency": "$US",
    "Marketing": 0.0732,
    "Utility": {
      "base_rate": 0.0160,
      "tiers": [
        { "from": 0, "to": 150000, "rate": 0.0160, "type": "List rate" },
        { "from": 150001, "to": 1000000, "rate": 0.0152, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4000000, "rate": 0.0144, "type": "Tier rate", "discount": "10%" },
        { "from": 4000001, "to": 25000000, "rate": 0.0136, "type": "Tier rate", "discount": "15%" },
        { "from": 25000001, "to": 50000000, "rate": 0.0128, "type": "Tier rate", "discount": "20%" },
        { "from": 50000001, "to": null, "rate": 0.0120, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0160,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0160, "type": "List rate" },
        { "from": 100001, "to": 300000, "rate": 0.0152, "type": "Tier rate", "discount": "5%" },
        { "from": 300001, "to": 1000000, "rate": 0.0144, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 10000000, "rate": 0.0136, "type": "Tier rate", "discount": "15%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0128, "type": "Tier rate", "discount": "20%" },
        { "from": 20000001, "to": null, "rate": 0.0120, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0160,
    "Authentication_International": "N/A"
  },
  {
    "Market": "South Africa",
    "Currency": "$US",
    "Marketing": 0.0379,
    "Utility": {
      "base_rate": 0.0095,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0095, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0090, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0086, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0081, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0076, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0071, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0095,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0095, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0090, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0086, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0081, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0076, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0071, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0095,
    "Authentication_International": {
      "base_rate": 0.0200,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0200, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0190, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0180, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0170, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0160, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0150, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "Spain",
    "Currency": "$US",
    "Marketing": 0.0707,
    "Utility": {
      "base_rate": 0.0200,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0200, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0190, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0180, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0170, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0160, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0150, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0200,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0200, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0190, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0180, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0170, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0160, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0150, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0200,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Sri Lanka",
    "Currency": "$US",
    "Marketing": 0.0732,
    "Utility": {
      "base_rate": 0.0020,
      "tiers": [
        { "from": 0, "to": 150000, "rate": 0.0020, "type": "List rate" },
        { "from": 150001, "to": 1000000, "rate": 0.0019, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4000000, "rate": 0.0018, "type": "Tier rate", "discount": "10%" },
        { "from": 4000001, "to": 25000000, "rate": 0.0017, "type": "Tier rate", "discount": "15%" },
        { "from": 25000001, "to": 50000000, "rate": 0.0016, "type": "Tier rate", "discount": "20%" },
        { "from": 50000001, "to": null, "rate": 0.0015, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0020,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0020, "type": "List rate" },
        { "from": 100001, "to": 300000, "rate": 0.0019, "type": "Tier rate", "discount": "5%" },
        { "from": 300001, "to": 1000000, "rate": 0.0018, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 10000000, "rate": 0.0017, "type": "Tier rate", "discount": "15%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0016, "type": "Tier rate", "discount": "20%" },
        { "from": 20000001, "to": null, "rate": 0.0015, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0020,
    "Authentication_International": {
      "base_rate": 0.1440,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.1440, "type": "List rate" },
        { "from": 100001, "to": 300000, "rate": 0.1368, "type": "Tier rate", "discount": "5%" },
        { "from": 300001, "to": 1000000, "rate": 0.1296, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 10000000, "rate": 0.1224, "type": "Tier rate", "discount": "15%" },
        { "from": 10000001, "to": 20000000, "rate": 0.1152, "type": "Tier rate", "discount": "20%" },
        { "from": 20000001, "to": null, "rate": 0.1080, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "Turkey",
    "Currency": "$US",
    "Marketing": 0.0109,
    "Utility": {
      "base_rate": 0.0009,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0009, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0009, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0008, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0008, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0007, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0007, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0009,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0009, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0009, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0008, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0008, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0007, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0007, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0009,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Ukraine",
    "Currency": "$US",
    "Marketing": 0.0860,
    "Utility": {
      "base_rate": 0.0298,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0298, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0283, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0268, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0253, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0238, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0224, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0298,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0298, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0283, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0268, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0253, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0238, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0224, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0298,
    "Authentication_International": {
      "base_rate": 0.0746,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0746, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0709, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0671, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0634, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0597, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0560, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "United Arab Emirates",
    "Currency": "$US",
    "Marketing": 0.0576,
    "Utility": {
      "base_rate": 0.0157,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0157, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0149, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0141, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0133, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0126, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0118, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0157,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0157, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0149, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0141, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0133, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0126, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0118, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0157,
    "Authentication_International": {
      "base_rate": 0.0510,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0510, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0485, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0459, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0434, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0408, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0383, "type": "Tier rate", "discount": "25%" }
      ]
    }
  },
  {
    "Market": "United Kingdom",
    "Currency": "$US",
    "Marketing": 0.0635,
    "Utility": {
      "base_rate": 0.0220,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0220, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0209, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0198, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0187, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0176, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0165, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0220,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0220, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0209, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0198, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0187, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0176, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0165, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0220,
    "Authentication_International": "N/A"
  },
  {
    "Market": "North America",
    "Currency": "$US",
    "Marketing": 0.0250,
    "Utility": {
      "base_rate": 0.0034,
      "tiers": [
        { "from": 0, "to": 80000, "rate": 0.0034, "type": "List rate" },
        { "from": 80001, "to": 750000, "rate": 0.0032, "type": "Tier rate", "discount": "5%" },
        { "from": 750001, "to": 2250000, "rate": 0.0031, "type": "Tier rate", "discount": "10%" },
        { "from": 2250001, "to": 3000000, "rate": 0.0029, "type": "Tier rate", "discount": "15%" },
        { "from": 3000001, "to": 6000000, "rate": 0.0027, "type": "Tier rate", "discount": "20%" },
        { "from": 6000001, "to": null, "rate": 0.0026, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0034,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0034, "type": "List rate" },
        { "from": 100001, "to": 500000, "rate": 0.0032, "type": "Tier rate", "discount": "5%" },
        { "from": 500001, "to": 2000000, "rate": 0.0031, "type": "Tier rate", "discount": "10%" },
        { "from": 2000001, "to": 5000000, "rate": 0.0029, "type": "Tier rate", "discount": "15%" },
        { "from": 5000001, "to": 10000000, "rate": 0.0027, "type": "Tier rate", "discount": "20%" },
        { "from": 10000001, "to": null, "rate": 0.0026, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0034,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Rest of Africa",
    "Currency": "$US",
    "Marketing": 0.0225,
    "Utility": {
      "base_rate": 0.0040,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0040, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0038, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0036, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0034, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0032, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0030, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0040,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0040, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0038, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0036, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0034, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0032, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0030, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0040,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Rest of Asia Pacific",
    "Currency": "$US",
    "Marketing": 0.0842,
    "Utility": {
      "base_rate": 0.0113,
      "tiers": [
        { "from": 0, "to": 150000, "rate": 0.0113, "type": "List rate" },
        { "from": 150001, "to": 1000000, "rate": 0.0107, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4000000, "rate": 0.0102, "type": "Tier rate", "discount": "10%" },
        { "from": 4000001, "to": 25000000, "rate": 0.0096, "type": "Tier rate", "discount": "15%" },
        { "from": 25000001, "to": 50000000, "rate": 0.0090, "type": "Tier rate", "discount": "20%" },
        { "from": 50000001, "to": null, "rate": 0.0085, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0113,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0113, "type": "List rate" },
        { "from": 100001, "to": 300000, "rate": 0.0107, "type": "Tier rate", "discount": "5%" },
        { "from": 300001, "to": 1000000, "rate": 0.0102, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 10000000, "rate": 0.0096, "type": "Tier rate", "discount": "15%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0090, "type": "Tier rate", "discount": "20%" },
        { "from": 20000001, "to": null, "rate": 0.0085, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0113,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Rest of Central & Eastern Europe",
    "Currency": "$US",
    "Marketing": 0.0860,
    "Utility": {
      "base_rate": 0.0212,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0212, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0201, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0191, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0180, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0170, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0159, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0212,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0212, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0201, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0191, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0180, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0170, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0159, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0212,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Rest of Latin America",
    "Currency": "$US",
    "Marketing": 0.0740,
    "Utility": {
      "base_rate": 0.0113,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0113, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0107, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0102, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 15000000, "rate": 0.0096, "type": "Tier rate", "discount": "15%" },
        { "from": 15000001, "to": 30000000, "rate": 0.0090, "type": "Tier rate", "discount": "20%" },
        { "from": 30000001, "to": null, "rate": 0.0085, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0113,
      "tiers": [
        { "from": 0, "to": 120000, "rate": 0.0113, "type": "List rate" },
        { "from": 120001, "to": 400000, "rate": 0.0107, "type": "Tier rate", "discount": "5%" },
        { "from": 400001, "to": 1000000, "rate": 0.0102, "type": "Tier rate", "discount": "10%" },
        { "from": 1000001, "to": 5000000, "rate": 0.0096, "type": "Tier rate", "discount": "15%" },
        { "from": 5000001, "to": 10000000, "rate": 0.0090, "type": "Tier rate", "discount": "20%" },
        { "from": 10000001, "to": null, "rate": 0.0085, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0113,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Rest of Middle East",
    "Currency": "$US",
    "Marketing": 0.0392,
    "Utility": {
      "base_rate": 0.0091,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0091, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0086, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0082, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0077, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0073, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0068, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0091,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0091, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0086, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0082, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0077, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0073, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0068, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0091,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Rest of Western Europe",
    "Currency": "$US",
    "Marketing": 0.0592,
    "Utility": {
      "base_rate": 0.0171,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0171, "type": "List rate" },
        { "from": 100001, "to": 1000000, "rate": 0.0162, "type": "Tier rate", "discount": "5%" },
        { "from": 1000001, "to": 4500000, "rate": 0.0154, "type": "Tier rate", "discount": "10%" },
        { "from": 4500001, "to": 40000000, "rate": 0.0145, "type": "Tier rate", "discount": "15%" },
        { "from": 40000001, "to": 80000000, "rate": 0.0137, "type": "Tier rate", "discount": "20%" },
        { "from": 80000001, "to": null, "rate": 0.0128, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0171,
      "tiers": [
        { "from": 0, "to": 300000, "rate": 0.0171, "type": "List rate" },
        { "from": 300001, "to": 2000000, "rate": 0.0162, "type": "Tier rate", "discount": "5%" },
        { "from": 2000001, "to": 10000000, "rate": 0.0154, "type": "Tier rate", "discount": "10%" },
        { "from": 10000001, "to": 20000000, "rate": 0.0145, "type": "Tier rate", "discount": "15%" },
        { "from": 20000001, "to": 40000000, "rate": 0.0137, "type": "Tier rate", "discount": "20%" },
        { "from": 40000001, "to": null, "rate": 0.0128, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0171,
    "Authentication_International": "N/A"
  },
  {
    "Market": "Other",
    "Currency": "$US",
    "Marketing": 0.0604,
    "Utility": {
      "base_rate": 0.0077,
      "tiers": [
        { "from": 0, "to": 80000, "rate": 0.0077, "type": "List rate" },
        { "from": 80001, "to": 750000, "rate": 0.0073, "type": "Tier rate", "discount": "5%" },
        { "from": 750001, "to": 2250000, "rate": 0.0069, "type": "Tier rate", "discount": "10%" },
        { "from": 2250001, "to": 3000000, "rate": 0.0065, "type": "Tier rate", "discount": "15%" },
        { "from": 3000001, "to": 6000000, "rate": 0.0062, "type": "Tier rate", "discount": "20%" },
        { "from": 6000001, "to": null, "rate": 0.0058, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Authentication": {
      "base_rate": 0.0077,
      "tiers": [
        { "from": 0, "to": 100000, "rate": 0.0077, "type": "List rate" },
        { "from": 100001, "to": 500000, "rate": 0.0073, "type": "Tier rate", "discount": "5%" },
        { "from": 500001, "to": 2000000, "rate": 0.0069, "type": "Tier rate", "discount": "10%" },
        { "from": 2000001, "to": 5000000, "rate": 0.0065, "type": "Tier rate", "discount": "15%" },
        { "from": 5000001, "to": 10000000, "rate": 0.0062, "type": "Tier rate", "discount": "20%" },
        { "from": 10000001, "to": null, "rate": 0.0058, "type": "Tier rate", "discount": "25%" }
      ]
    },
    "Service": 0.0077,
    "Authentication_International": "N/A"
  }
]

// Helper function to calculate pricing based on message volume
export const calculateTierPrice = (tiers, messageCount) => {
  if (!tiers || !Array.isArray(tiers)) {
    return null;
  }
  
  if (messageCount <= 0) {
    return {
      totalCost: 0,
      averageRate: 0,
      appliedTiers: []
    };
  }
  
  let totalCost = 0;
  let appliedTiers = [];
  let remainingMessages = messageCount;
  
  for (let tier of tiers) {
    if (remainingMessages <= 0) break;
    
    let tierStart = tier.from;
    let tierEnd = tier.to || Infinity;
    
    // Calculate how many messages fall in this tier
    let messagesInThisTier = 0;
    
    if (remainingMessages > 0) {
      // For first tier (0-100000), we want to use messages 1-100000
      let maxMessagesInTier = tierEnd - tierStart;
      if (tier.from === 0) {
        maxMessagesInTier = tierEnd; // For 0-100000, max is 100000
      }
      
      if (remainingMessages <= maxMessagesInTier) {
        // All remaining messages fit in this tier
        messagesInThisTier = remainingMessages;
        remainingMessages = 0;
      } else {
        // Only part of messages fit in this tier
        messagesInThisTier = maxMessagesInTier;
        remainingMessages -= maxMessagesInTier;
      }
      
      if (messagesInThisTier > 0) {
        let tierCost = messagesInThisTier * tier.rate;
        totalCost += tierCost;
        
        let rangeDisplay = tier.from === 0 ? 
          `1 - ${tier.to ? tier.to.toLocaleString() : 'unlimited'}` :
          `${(tier.from + 1).toLocaleString()} - ${tier.to ? tier.to.toLocaleString() : 'unlimited'}`;
        
        appliedTiers.push({
          tier_range: rangeDisplay,
          messages: messagesInThisTier,
          rate: tier.rate,
          cost: tierCost,
          type: tier.type,
          discount: tier.discount || null
        });
      }
    }
  }
  
  return {
    totalCost: totalCost,
    averageRate: messageCount > 0 ? totalCost / messageCount : 0,
    appliedTiers: appliedTiers,
    totalMessages: messageCount
  };
};

// Helper function to get pricing for a specific country and message type
export const getCountryPricing = (marketName, messageType, messageCount = 0) => {
  const country = countries.find(c => c.Market === marketName);
  if (!country) return null;
  
  let pricingData = country[messageType];
  
  // Handle both old flat rate format and new tier format
  if (typeof pricingData === 'number') {
    return { rate: pricingData, type: 'Flat rate' };
  } else if (typeof pricingData === 'object' && pricingData.tiers) {
    return calculateTierPrice(pricingData.tiers, messageCount);
  }
  
  return pricingData;
};

// Helper function to get all available tiers for a specific message type
export const getAvailableTiers = (marketName, messageType) => {
  const country = countries.find(c => c.Market === marketName);
  if (!country) return null;
  
  const pricingData = country[messageType];
  if (typeof pricingData === 'object' && pricingData.tiers) {
    return pricingData.tiers;
  }
  
  return null;
};